import type { Client } from '@urql/core'
import { graphql } from 'app/generated/gql'

import type { Role as RoleType, RoleListResult } from 'app/generated/graphql'
import { EntityStore } from './EntityStore'

const ROLE_FIELDS = `createdDate id isDefault name orgId permissions updatedDate version workspaceId`

const LIST_QUERY = graphql(`
  query Roles($search: String, $pagination: PaginationInput, $sort: SortInput) {
    roles(search: $search, pagination: $pagination, sort: $sort) {
      hits {
        createdDate
        id
        isDefault
        name
        orgId
        permissions
        updatedDate
        version
        workspaceId
      }
      total
      page
    }
  }
`)

const GET_QUERY = graphql(`
  query Role($id: ID!) {
    role(id: $id) {
      createdDate
      id
      isDefault
      name
      orgId
      permissions
      updatedDate
      version
      workspaceId
    }
  }
`)

const CREATE_MUTATION = graphql(`
  mutation CreateRole($input: CreateRoleInput!) {
    createRole(input: $input) {
      createdDate
      id
      isDefault
      name
      orgId
      permissions
      updatedDate
      version
      workspaceId
    }
  }
`)

const UPDATE_MUTATION = graphql(`
  mutation UpdateRole($id: ID!, $input: UpdateRoleInput!) {
    updateRole(id: $id, input: $input) {
      createdDate
      id
      isDefault
      name
      orgId
      permissions
      updatedDate
      version
      workspaceId
    }
  }
`)

const DELETE_MUTATION = graphql(`
  mutation DeleteRole($id: ID!) {
    deleteRole(id: $id)
  }
`)

export class RoleStore extends EntityStore<RoleType, RoleListResult, typeof CREATE_MUTATION, typeof UPDATE_MUTATION> {
  constructor(client: Client) {
    super(client, {
      listQuery: LIST_QUERY,
      getQuery: GET_QUERY,
      createMutation: CREATE_MUTATION,
      updateMutation: UPDATE_MUTATION,
      deleteMutation: DELETE_MUTATION,
      typename: `Role`,
      extractList: (data: any) => data.roles,
      extractOne: (data: any) => data.role,
      extractMutated: (data: any) => data.updateRole ?? data.createRole,
    })
  }
}
